
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component<QuantityInput>({})
export default class QuantityInput extends Vue {
	@Prop({ type: String, required: true }) private id!: string;
	@Prop({ type: Number, required: true }) private quantity!: number;
	@Prop({ type: Boolean, required: false, default: false }) private disabled!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private disableDecrement!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private disableIncrement!: boolean;
	@Prop({ type: Boolean, required: false, default: false }) private directInput!: boolean;
	@Prop({ type : String, default: 'label-md' }) private valueClass!: string;

	/**
	 * Strip non-numeric characters and limit to 3 digits
	 *
	 * @param {Event} event
	 * @return {void}
	 */
	private handleInput(event: Event): void {
		const input = event.target as HTMLInputElement;
		const numericValue = input.value.replace(/\D/g, '');
		const limitedValue = numericValue.slice(0, 3);

		if (limitedValue !== input.value) {
			input.value = limitedValue;
		}
	}

	/**
	 * Ensure that the input is within the allowed limit.
	 *
	 * @param {Event} event
	 * @return {void}
	 */
	private handleBlur(event: Event): void {
		const input = event.target as HTMLInputElement;
		const value = input.value.trim();
		let finalQuantity: number;

		if (value === '' || Number(value) <= 0) {
			finalQuantity = 1;
		}
		else {
			finalQuantity = Number(value);
		}
		if (finalQuantity !== this.quantity) {
			this.$emit('quantity-changed', finalQuantity);
		}

		this.$nextTick(() => {
			input.value = String(this.quantity > 0 ? this.quantity : 1);
		});
	}
}
